import React from "react";
import styles from "./ToggleSwitch.module.scss";

export interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  id?: string;
  leftAlign?: boolean;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  label,
  id,
  leftAlign
}) => {
  const handleToggle = () => {
    onChange(!checked);
  };

  return (
    <div className={`
      ${styles.toggleWrapper}
      ${leftAlign ? styles.alignLeft : ""}
    `}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <button
        type="button"
        id={id}
        className={`${styles.toggle} ${checked ? styles.toggleChecked : ""}`}
        onClick={handleToggle}
        role="switch"
        aria-checked={checked}
      >
        <span className={styles.toggleThumb} />
      </button>
    </div>
  );
};
